import { TournamentDetail, TournamentSummary } from 'modules/jogador/tournaments/types';

export const TOURNAMENTS: TournamentSummary[] = [
  {
    id: 'open-praia-norte',
    sport: 'Beach Tennis',
    name: 'Open Praia Norte',
    dateLabel: '28-29 set',
    arenaName: 'Arena Praia Norte',
    entryFeeLabel: 'R$ 180/dupla',
  },
];

export const TOURNAMENT_DETAILS: Record<string, TournamentDetail> = {
  'open-praia-norte': {
    id: 'open-praia-norte',
    sport: 'Beach Tennis',
    name: 'Open Praia Norte',
    dateLabel: '28-29 set',
    arenaName: 'Arena Praia Norte',
    entryFeeLabel: 'R$ 180/dupla',
    cancelableUntilLabel: '21 set',
    quotaAmount: 90,
    categories: [
      { id: 'mista-c', name: 'Mista C', spotsLabel: '14/16 vagas · sáb 08:00', status: 'open' },
      { id: 'masculina-b', name: 'Masculina B', spotsLabel: 'esgotada · lista de espera (3)', status: 'full' },
      { id: 'feminina-open', name: 'Feminina Open', spotsLabel: '9/16 vagas · dom 08:00', status: 'available' },
    ],
    duoPartner: { name: 'Rafael Nunes', level: 'nível C' },
  },
};
